<template>
  <div class="row column">
    <br />
    <h5 class="text-center">
      <unicon name="chart-line" :fill="secCol" style="margin-right: 8px;">
      </unicon>
      <span class="text-barlow-condensed">{{ $t("analytics") }}</span>
    </h5>

    <ul
      class="vertical menu kal-aside-menu__list"
      data-responsive-menu="drilldown medium-accordion"
    >
      <li v-for="(item, index) in menu.analytics.children" :key="index">
        <a @click="toggleList(index)">
          <unicon :name="item.icon" :fill="secCol"></unicon>
          <router-link :to="item.link">
            <span class="text-logo">{{ $t(item.text) }}</span>
          </router-link>
          <i
            class="fas fr"
            v-bind:class="{
              'fa-angle-down': !item.isOpen,
              'fa-angle-up': item.isOpen,
            }"
          ></i>
        </a>
        <transition name="fade" mode="out-in">
          <ul class="ml-50" v-if="item.isOpen === true" :key="index">
            <li class="color-gray" v-for="(child, i) in item.children" :key="i">
              <router-link :to="child.link">{{ $t(child.text) }}</router-link>
            </li>
          </ul>
        </transition>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "AnalyticsMenu",
  data() {
    let { secCol } = this.$store.getters;

    return {
      secCol,
      showSession: false,
    };
  },
  computed: {
    ...mapState(["menu"]),
  },
  methods: {
    toggleList(id) {
      this.menu.analytics.children[id].isOpen = !this.menu.analytics.children[
        id
      ].isOpen;
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.color-gray > a {
  padding-left: 8px;
}

.ml-50 {
  margin-left: 50px;
}

.fr {
  float: right;
}

.kal-dashboard .position-left.reveal-for-large {
  margin-left: 0px;
}
</style>
